<template>
	<div class="pageSetting-body">
		<div class="fx-header">
			<p>页面装修</p>
		</div>
		<div class="body-box">
			<div class="input-box">
				<span>页面名称：</span>
				<el-input
					class="search-input"
					v-model="pageName"
					placeholder="请输入页面名称"
					size="small"
					@keyup.enter.native="search">
				</el-input>
				<el-button type="primary" size="mini" class="btn" @click="search">查询</el-button>
			</div>
			<div class="customList-btn-box">
				<el-button type="primary" size="mini" v-if="AuthorityList['16_0006_0003_00']" class="btn" @click="addClick">新建</el-button>
				<el-button type="primary" size="mini" v-if="AuthorityList['16_0006_0004_00']" class="btn" @click="delListClick">删除</el-button>
			</div>
			<div class="main-table-box">
				<div style="flex: 1">
					<el-table
					class="grid-content"
					:data="tableData"
					border
					stripe
					@selection-change="selectionChangeHandle"
					ref="table"
					height="100%"
					>
						<el-table-column
							type="selection"
							align="center"
							width="50">
						</el-table-column>
						<el-table-column
							prop="styleName"
							label="页面名称"
							align="center">
						</el-table-column>
						<el-table-column
							prop="createdate"
							label="创建时间"
							align="center">
						</el-table-column>
						<el-table-column label="操作" width="220" align="center">
							<template slot-scope="scope">
								<el-button v-if="AuthorityList['16_0006_0002_00']" type='text' size="mini" @click="rowClick(scope.row)">编辑</el-button>
								<el-button v-if="AuthorityList['16_0006_0004_00']"  type='text' size="mini" @click="delClick(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handlePageChange"
						:current-page="page"
						:page-sizes="[20,40, 60, 100]"
						:page-size="size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalCount">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'pageSetting',
	components: {
	},
	data () {
		return {
			ids: [],
			pageName: '',
			page: 1,
			size: 20,
			totalCount: 0,
			tableData: [],
			AuthorityList: {
				'16_0006_0001_00': false,
				'16_0006_0002_00': false,
				'16_0006_0003_00': false,
				'16_0006_0004_00': false
			}
		}
	},
	created () {
		this.getAuthority('16_0006_0000_00')
		this.getList()
	},
	methods: {
		addClick () {
			window.sessionStorage.removeItem('customPageId')
			this.$router.push({ path: '/main/customPage' })
		},
		delClick (row) {
			this.$confirm(`删除自定义页面后，相关装修模块的绑定关系均会删除，是否确定删除？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let msg = '删除自定义页面，页面名称：' + row.styleName
				let url = window.location.href.split('?')[0]
				url = url.replace(window.location.origin, '').substring(1)
				let param = {
					styleids: row.id,
					logMessage: {
						message: msg,
						referer: url
					}
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/style/del`,
					data: param
				}).then(res => {
					if (res.result) {
						this.$message({
							message: `删除装修模块成功!`,
							type: 'success'
						})
						this.search()
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		delListClick () {
			if (this.ids.length === 0) {
				this.$message.error('请选择装修模块')
				return false
			}
			this.$confirm(`删除自定义页面后，相关装修模块的绑定关系均会删除，是否确定删除？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let idArr = []
				let nameArr = []
				this.ids.forEach(item => {
					idArr.push(item.id)
					nameArr.push(item.styleName)
				})
				let msg = '删除自定义页面，页面名称：' + nameArr.join(',')
				let url = window.location.href.split('?')[0]
				url = url.replace(window.location.origin, '').substring(1)
				let param = {
					styleids: idArr.join(','),
					logMessage: {
						message: msg,
						referer: url
					}
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/style/del`,
					data: param
				}).then(res => {
					if (res.result) {
						this.$message({
							message: `删除装修模块成功!`,
							type: 'success'
						})
						this.search()
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		selectionChangeHandle (value) {
			this.ids = value
		},
		rowClick (item) {
			window.sessionStorage.setItem('customPageId', item.id)
			this.$router.push({ path: '/main/customPage' })
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.getList()
		},
		handlePageChange (value) {
			this.page = value
			this.getList()
		},
		getList () {
			let params = {
				styleType: 4,
				styleName: this.pageName,
				page: this.page,
				size: this.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/style/list`,
				data: params
			}).then(res => {
				this.tableData = res.recordList
				this.totalCount = res.recordCount
			})
		},
		search () {
			this.page = 1
			this.size = 20
			this.getList()
		}
	}
}
</script>

<style lang="stylus" scoped>
.pageSetting-body{
	flex: 1
	display flex
	flex-direction column
	.body-box{
		flex: 1
		flex-direction:column;
		display: flex;
		width :100%;
		padding-bottom :10px
	}
	.customList-btn-box{
		margin-bottom: 20px
		text-align: left;
	}
	.main-table-box{
		flex: 1;
		flex-direction: column;
		display: flex
	}
	.input-box {
		display: flex
		align-items: center;
		padding: 20px 0;
	}
	.el-input {
		width: 200px
	}
	.btn {
		margin-left: 5px
	}
	.pagination{
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center
	}
}

</style>
<style lang="stylus">

</style>

